import {isArray, isUndefined} from 'lodash-es';
import {DEFAULT_LANG} from '../app.const';

let LANG: string = DEFAULT_LANG;
let baseTranslation: any = [];
let overridesTranslation: any = [];

let exclusion: string[] = ['constructor', 'children', 'window', 'undefined'];

export function changeLanguage(code: string): void {
    LANG = code;
}

export function getLanguage(): string {
    return LANG;
}

export function setBaseTranslations(translations: any[]): void {
    baseTranslation = translations;
}
export function overrideTranslations(translations: any): void {
    overridesTranslation.push(translations);
}
export function getStrings<Type>(strings?: any): Type {
    return getLang(strings) as Type;
}

export function getLang(translations?: any): any {
    if (isUndefined(translations)) {
        translations = [];
    } else if (!isArray(translations)) {
        translations = [translations];
    }
    const groups: any[] = overridesTranslation
        .reverse()
        .concat(translations.reverse().concat(baseTranslation.reverse()));
    return new Proxy(
        {},
        {
            get: (object: any, property: string): any => {
                try {
                    if (exclusion.indexOf(property) !== -1) {
                        return;
                    }
                    if (property === '_lang_') {
                        return LANG;
                    } else if (property === 'format') {
                        return (...args: any[]): any => {
                            try {
                                let translation: string = translate(groups, args.shift());
                                args.forEach((param: any, n: number) => {
                                    translation = translation.split(`{${n}}`).join(param === undefined ? '' : param);
                                });
                                return translation;
                            } catch (e) {
                                console.warn(e.message);
                            }
                        };
                    } else if (property === 'dec') {
                        // declension
                        return (key: string, count: number): string => {
                            const postfixes: string[] = ['_singular', '_dual', '_plural'];
                            const cases: number[] = [2, 0, 1, 1, 1, 2];
                            let postfix: string =
                                postfixes[
                                    count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]
                                ];
                            if (postfix === postfixes[0]) {
                                // _singular = обычное значение lang
                                postfix = '';
                            }
                            return translate(groups, key + postfix);
                        };
                    } else {
                        return translate(groups, property);
                    }
                } catch (e) {
                    console.warn(e.message);
                }
            }
        }
    );
}

export function lang(translations?: any): Function {
    return function (target: any, name: string): void {
        target[name] = getLang(translations);
    };
}

function translate(groups: any[], property: string): string {
    for (let group of groups) {
        if (group.hasOwnProperty && group.hasOwnProperty(property)) {
            const fieldValue: any = group[property];
            return fieldValue[LANG] ? fieldValue[LANG] : fieldValue[DEFAULT_LANG];
        }
    }
    return property;
}
